module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Gb-Da-Eb.93795e83.png";